module.exports = "data:image/png;base64,UklGRhQBAABXRUJQVlA4WAoAAAAQAAAADwAADwAAQUxQSGsAAAABt6CwbSM1dXzPDBERIM3q3nO1Wr8ezp4tBAbDSJKU7LvgcLf5BwtLChH9nwCo87ntViZ3nKeQnAW1CIMGNdWTV1ba5bRNQXA2yJUetYUP9IP7j4dTi86iVVr4ah1YuOL7sZTdonC5PWfCOwBWUDggggAAALACAJ0BKhAAEAACADQlAE6A0i/+08gEF1xMHNBhAAD+2O3+ADzKgEhQ6YY6Qy9xqbF/rRf1o0O+MRZvcAm1T+mKHt+XdrysWCVClzValuNJx4m1zF2uH+f/Ax9ca+t4r/scR8dFgXHI2y8BOM0EBE+fnb3AHIPpPmSz5SqEtQEkAAA="


//////////////////
// WEBPACK FOOTER
// ./src/Assets/icons/function.png
// module id = 56
// module chunks = 0